import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';

import { AbpSessionService } from '@abp/session/abp-session.service';
import { PermissionCheckerService } from '@abp/auth/permission-checker.service';
import { FeatureCheckerService } from '@abp/features/feature-checker.service';
import { LocalizationService } from '@abp/localization/localization.service';
import { SettingService } from '@abp/settings/setting.service';
import { NotifyService } from '@abp/notify/notify.service';
import { MessageService } from '@abp/message/message.service';
import { LogService } from '@abp/log/log.service';
import { AbpMultiTenancyService } from '@abp/multi-tenancy/abp-multi-tenancy.service';
import { AbpHttpConfiguration } from '@abp/abpHttpInterceptor';
import { AbpUserConfigurationService } from '@abp/abp-user-configuration.service';
import { TokenService } from '@abp/auth/token.service';
import { UtilsService } from '@abp/utils/utils.service';

@NgModule({
    imports: [
        HttpClientModule,
        HttpClientJsonpModule
    ]
})
export class AbpProxyModule {
    static forRoot(): ModuleWithProviders<AbpProxyModule> {
        return {
            ngModule: AbpProxyModule,
            providers: [
                AbpSessionService,
                PermissionCheckerService,
                FeatureCheckerService,
                LocalizationService,
                SettingService,
                NotifyService,
                MessageService,
                LogService,
                AbpMultiTenancyService,
                AbpUserConfigurationService,
                AbpHttpConfiguration,
                TokenService,
                UtilsService
            ]
        };
    }
}
